export default __webpack_public_path__ + "static/media/icon-business.5a845efa.svg";